module.exports = __webpack_public_path__ + "static/team10-2d1e49ea58dab1d741cc08d222af0789.jpg";